import { Base } from '@studiometa/js-toolkit';
import scrollTo from '@studiometa/js-toolkit/utils/scrollTo';

/**
 * @typedef {Object} ScrollToRefs
 */

/**
 * @typedef {Object} ScrollToInterface
 * @property {ScrollToRefs} $refs
 * @property {HTMLElement} target
 */

/**
 * Homepage class.
 */
export default class ScrollTo extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'ScrollTo',
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {ScrollTo & ScrollToInterface}
   */
  mounted() {
    this.target = document.querySelector(this.$el.dataset.target);
  }

  /**
   * Scroll to the target.
   *
   * @this {ScrollTo & ScrollToInterface}
   */
  onClick() {
    scrollTo(this.target, {
      dampFactor: 0.1,
    });
  }
}
